import type { IssueReferenceName } from 'shared/domain/issue/issueReferences';
import { FieldSkeleton } from 'shared/types/form';

export interface LegacyIssueForm {
  primaryFields: FieldSkeleton[];
  extendedFields: FieldSkeleton[];
}

export enum EntityStatuses {
  NOT_FOUND = 'NOT_FOUND',
  DELETED = 'DELETED',
}

export enum ENTITY {
  PROJECT = 'project',
  EVENT = 'event',
  DOCUMENT = 'document',
  ISSUE = 'issue',
  SITE = 'site',
  LEVEL = 'level',
  PROCESS = 'process',
}

export interface EntityStatusType {
  entity: ENTITY;
  status: EntityStatuses;
}

/** What the issue view knows about the issue it opens. */
export interface IssueLoadState {
  /** The issue could not be read. */
  hasError: boolean;
  /** The site, level or process the issue refers to that does not exist. */
  missingReference?: IssueReferenceName;
}

export interface RouteProjectState {
  isSelected: boolean;
  isProjectListLoaded: boolean;
  isAccessible: boolean;
}

/** The ids of the route that point into the issue. */
export interface IssueDeepLink {
  eventId?: string;
  documentId?: string;
  linkedDocumentationVersionId?: string;
}

export enum DeepLinkTarget {
  /** What the link points to is shown. */
  shown = 'shown',
  /** The link is stale: the issue itself is shown. */
  issue = 'issue',
  /** What the link points to is missing or deleted. */
  missing = 'missing',
}

export type DeepLinkResolution =
  | { target: DeepLinkTarget.shown | DeepLinkTarget.issue }
  | { target: DeepLinkTarget.missing; status: EntityStatusType };
